import React from 'react';
import Navbar from '../components/Navbar'; // Import your Navbar component
import '../styles/Resources.css';

const Resource = () => {
  const resources = {
    blogs: [
      { id: 1, name: 'Blog 1', image: 'https://placehold.co/300x200/ff7f7f/333333?text=Blog+1' },
      { id: 2, name: 'Blog 2', image: 'https://placehold.co/300x200/7f7fff/333333?text=Blog+2' },
      { id: 3, name: 'Blog 3', image: 'https://placehold.co/300x200/7fff7f/333333?text=Blog+3' },
      { id: 4, name: 'Blog 4', image: 'https://placehold.co/300x200/ff7fff/333333?text=Blog+4' }
    ],
    research: [
      { id: 1, name: 'Research 1', image: 'https://placehold.co/300x200/7fffff/333333?text=Research+1' },
      { id: 2, name: 'Research 2', image: 'https://placehold.co/300x200/ff8c00/333333?text=Research+2' },
      { id: 3, name: 'Research 3', image: 'https://placehold.co/300x200/8a2be2/333333?text=Research+3' },
      { id: 4, name: 'Research 4', image: 'https://placehold.co/300x200/4b0082/333333?text=Research+4' }
    ],
    books: [
      { id: 1, name: 'Book 1', image: 'https://placehold.co/300x200/ff0000/333333?text=Book+1' },
      { id: 2, name: 'Book 2', image: 'https://placehold.co/300x200/0000ff/333333?text=Book+2' },
      { id: 3, name: 'Book 3', image: 'https://placehold.co/300x200/00ff00/333333?text=Book+3' },
      { id: 4, name: 'Book 4', image: 'https://placehold.co/300x200/ffff00/333333?text=Book+4' }
    ]
  };

  const handleCardClick = (e) => {
    e.preventDefault();
    console.log('Card clicked');
  };

  return (
    <>
      <Navbar /> {/* Navbar is rendered at the top of the page */}
      <div className="resource-container">
        <h1 className="main-title">All our Resource Collections</h1>

        <section className="resource-section">
          <h2>Blogs & Articles:</h2>
          <div className="cards-container">
            {resources.blogs.map(item => (
              <a href="#" onClick={handleCardClick} key={item.id} className="card">
                <div className="card-inner">
                  <img src={item.image} alt={item.name} />
                  <div className="card-name">{item.name}</div>
                </div>
              </a>
            ))}
          </div>
          <a href="#" onClick={handleCardClick} className="view-more">View more</a>
        </section>

        <section className="resource-section">
          <h2>Research works:</h2>
          <div className="cards-container">
            {resources.research.map(item => (
              <a href="#" onClick={handleCardClick} key={item.id} className="card">
                <div className="card-inner">
                  <img src={item.image} alt={item.name} />
                  <div className="card-name">{item.name}</div>
                </div>
              </a>
            ))}
          </div>
          <a href="#" onClick={handleCardClick} className="view-more">View more</a>
        </section>

        <section className="resource-section">
          <h2>Books</h2>
          <div className="cards-container">
            {resources.books.map(item => (
              <a href="#" onClick={handleCardClick} key={item.id} className="card">
                <div className="card-inner">
                  <img src={item.image} alt={item.name} />
                  <div className="card-name">{item.name}</div>
                </div>
              </a>
            ))}
          </div>
          <a href="#" onClick={handleCardClick} className="view-more">View more</a>
        </section>
      </div>
    </>
  );
};

export default Resource;
